export class UnexpectedResultFormatError extends Error {
  constructor () {
    super('Algo de errado aconteceu. Resultado com formato inválido')
    this.name = 'UnexpectedResultFormatError'
  }
}
